import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { blobUrl } from "@/lib/scanOptions";

export const TopBanner = () => {
  const [cfg, setCfg] = useState(null);
  const [srcs, setSrcs] = useState({});
  const [i, setI] = useState(0);
  useEffect(() => {
    api.get("/banners/active").then(async (r) => {
      setCfg(r.data);
      const entries = await Promise.all(r.data.items.map(async (b) => [b.id, await blobUrl(`/banners/${b.id}/image`).catch(() => null)]));
      setSrcs(Object.fromEntries(entries));
    }).catch(() => {});
  }, []);
  const items = (cfg?.items || []).filter((b) => srcs[b.id]);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), cfg.settings.rotate_seconds * 1000);
    return () => clearInterval(t);
  }, [items.length, cfg?.settings.rotate_seconds]);
  if (!items.length) return null;
  const b = items[i % items.length];
  const { height, width } = cfg.settings;
  const img = <img src={srcs[b.id]} alt={b.title} className="w-full h-full object-cover" />;
  return (
    <div data-testid="top-banner" className="mb-4 mx-auto rounded-md overflow-hidden bg-slate-200" style={{ height, width: width || "100%", maxWidth: "100%" }} title={b.title}>
      {b.link_url ? <a href={b.link_url} target="_blank" rel="noreferrer" data-testid="top-banner-link">{img}</a> : img}
    </div>
  );
};
